// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n@media (max-width: 1024px) {\n.app.indent {\n        padding-top: 120px;\n}\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
